var App = (function (app) {
    'use strict';

    app.clientsTable = function() {
        var $tables = $('.js-client-table');

        $tables.each(function() {
            var $table = $(this),
                $rows = $table.find('.js-client-row'),
                $inputs = $table.find('.js-client-input'),
                timer = -1;

            findRows();

            $inputs.filter('input[type="text"]').on('keyup', function(e) {
                if (timer > -1) {
                    clearTimeout(timer);
                    timer = -1;
                }

                timer = setTimeout(findRows, 300);
            });

            $inputs.filter('select').on('change', function(e) {
                findRows();
            });

            $rows.click(function() {
                document.location.href = $(this).data('href');
            });

            function findRows() {
                var filter = {};

                for (var i = 0; i < $inputs.length; i ++) {
                    var $input = $inputs.eq(i),
                        value = '';

                    if ($input.is('select')) {
                        value = $input.find('option:selected').val();
                        if (value) {
                            filter[ $input.attr('name') ] = new RegExp('^' + value + '$');
                        }
                    } else {
                        value = $input.val();
                        if (value) {
                            filter[ $input.attr('name') ] = new RegExp(value, 'i');
                        }
                    }
                }

                for (var i = 0; i < $rows.length; i ++) {
                    var $row = $rows.eq(i),
                        $cells = $row.find('.js-client-cell'),
                        isFound = true;

                    for (var j = 0; j < $cells.length; j ++) {
                        var $cell = $cells.eq(j),
                            value = filter[ $cell.data('name') ];

                        if (!value) continue;

                        if (!value.test($cell.data('text'))) {
                            isFound = false;
                            break;
                        }
                    }

                    if (isFound) {
                        $row.show();
                    } else {
                        $row.hide();
                    }
                }

                var $selectedRows = $table.find('.js-client-row:visible');
                var selectedRowsCount = $selectedRows.length;
                $('.selected-rows-count').text(selectedRowsCount);
            }
        });
    };

    return app;
})(App || {});
